import 'datatables.net-dt/css/jquery.dataTables.css'
import 'datatables.net-buttons-dt/css/buttons.dataTables.css'
import 'datatables.net-rowgroup-dt/css/rowGroup.dataTables.min.css'
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

import React, { Component } from 'react';
import { translate } from 'react-i18next';
import swal from 'sweetalert';
import moment from 'moment';

const $ = require('jquery');
$.DataTable = require('datatables.net-dt');



pdfMake.vfs = pdfFonts.pdfMake.vfs;

const jzip = require('jszip');
require('datatables.net-buttons/js/buttons.html5.min');
window.JSZip = jzip;

require('datatables.net-rowgroup-dt/js/rowGroup.dataTables.min');

var session = sessionStorage.getItem('health_facilities_name');
var Config = require('../../../../config');
var report = require('../../../generics/report_head');

class Crossmatch extends Component {
	constructor(props) {
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.searching = this.searching.bind(this);
		this.isValidForm = this.isValidForm.bind(this);
		this.showCtrlError = this.showCtrlError.bind(this);
		this.generatePdf = this.generatePdf.bind(this);
		this.generateExcel = this.generateExcel.bind(this);

		this.setTable = this.setTable.bind(this);
		this.dateCompare = this.dateCompare.bind(this);

		this.state = {
			start_date: "",
			end_date: "",
			report_type: "",
			listado: [],

			//test datatable to export
			columns: [
				{ title: 'Muestra', width: '10%' },
				{ title: 'F. Petición', width: '15%' },
				{ title: 'F. Muestra', width: '15%' },
				{ title: 'F. Reserva', width: '15%' },
				{ title: 'Unidad', width: '10%' },
				{ title: 'Usuario', width: '35%' },
			],
			columns_list: [[
				{ title: 'Muestra' },
				{ title: 'F. Petición' },
				{ title: 'F. Muestra' },
				{ title: 'F. Reserva' },
				{ title: 'Unidad' },
				{ title: 'Usuario' },
			]],

			columns_results: [],
			filename: "Reporte de Pruebas Cruzadas",
			date_hour: "",
			medical: "",
			total: "",
			buttonsState: true,
			pdf_listado: [],
			pdf_results: [],
		}
	}

	componentWillMount() {
		var medical = JSON.parse(sessionStorage.getItem('medical_staff'));

		this.setState({
			health_facilities_id: sessionStorage.getItem('health_facilities_id'),
			medical: (medical.lastname1 !== null ? medical.lastname1 : "") + ' ' +
				(medical.lastname2 !== null ? medical.lastname2 : "") + ' ' + medical.names
		});

		if (!this.props.hiddeToReport) {
			this.props.reload();
		}

	}

	componentDidMount() {
		this.props.waiting.handleShow('Cargando...');
		setTimeout(()=>{
			this.props.waiting.handleClose();
		}, 300)
		fetch(Config.default.apiGateway.URL + 'offers?option=date', {
			method: 'get',
			headers: new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token"),
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
			.then(response => response.json())
			.then(response => {
				var aux = response.split('|');
				var hours = this.getHourFormat(aux[1]);

				this.setState({
					date_hour: aux[0] + ' ' + hours,
				});
			})

		this.setTable();
	}

	getHourFormat(hr) {
		var format = hr.split(' ');
		var hrs = format[0].split(':');
		var ampm = format.length === 2 ? format[1] : format[1] + ' ' + format[2];
		var hour = parseInt(hrs[0], 10);
		var minute = parseInt(hrs[1], 10);

		if ((ampm === "PM" || ampm === "p. m.") && hour < 12) hour += 12;

		if ((ampm === "AM" || ampm === "a. m.") && hour === 12) hour -= 12;

		if (hour < 10) hour = '0' + hour;

		if (minute < 10) minute = '0' + minute;
		var nvaHour = hour + ':' + minute;

		return nvaHour;
	}

	setTable() {
		this.$el = $(this.el);
		var fechas = "Del: " + moment(this.state.start_date).format("DD/MM/YYYY") +
			" Al: " + moment(this.state.end_date).format("DD/MM/YYYY");

		if (!this.state.columns || this.state.columns.length === 0) {
			console.warn('No hay columnas definidas para la tabla');
			return;
		}

		if (!this.state.listado) {
			this.setState({ listado: [] });
		}

		try {
			var table = this.$el.DataTable({
				dom: 'frtip',
				data: this.state.listado || [],
				columns: this.state.columns || [],
				oLanguage: {
					"sProcessing": "Procesando...",
					"sZeroRecords": "No se encontraron resultados",
					"sEmptyTable": "Ningún dato disponible en esta tabla",
					"sInfoPostFix": "",
					"sSearch": "Buscar:",
					"sUrl": "",
					"sInfoThousands": ",",
					"sLoadingRecords": "Cargando...",
					"fnInfoCallback": null,
				},
				paging: false,
				responsive: false,
				searching: false,
				scrollY: "32em",
				scrollX: true,
				autoWidth: false,
				ordering: false,
				info: false
			});
		} catch (error) {
			console.error('Error al crear DataTable:', error);
			this.props.waiting.handleClose();
			swal('Error', 'Error al cargar la tabla de datos', 'error');
		}

		// if (table.rows().indexes().length === 0 ) {
		// 	table.buttons('.buttons-html5').disable();
		// }else {
		// 	table.buttons('.buttons-html5').enable();
		// }
	}

	handleChange(e) {

		const { name, value } = e.target;

		this.setState(
			prevState => {
				let newFilename = prevState.filename;

				if (name === "report_type") {
					if (value === "DETALLADO") {
						newFilename = "Reporte de Pruebas Cruzadas";
					} else if (value === "ESTADISTICO") {
						newFilename = "Reporte Bolsas con Pruebas de Compatibilidad";
					} else {
						newFilename = "";
					}
				}

				return {
					[name]: value,
					filename: newFilename,
					report_type: value,
					listado: [],
					pdf_listado: [],
					total: 0,
					buttonsState: true
				};
			}
		);

        if ($.fn.DataTable.isDataTable(this.el)) {
            $(this.el).DataTable().destroy();
            $(this.el).empty();
        }

		this.setState({
			[e.target.name]: e.target.value
		});

		if (document.getElementById(e.target.name).className.includes('error')) {
			document.getElementById(e.target.name).classList.remove('error');
		}

	}

	searching() {
		if (this.isValidForm()) {
			if (this.dateCompare()) {
				this.props.waiting.handleShow('Buscando...');

				if (this.state.report_type === "DETALLADO") {
					this.crossmatchTime();
				} else if (this.state.report_type === "ESTADISTICO") {
					this.compatibilitySamplebags();
				} else {
					this.props.waiting.handleClose();
					swal('Error', 'Reporte no seleccionado', 'error');
				}

			} else {
				swal('Error', 'La Fecha Hasta debe ser mayor o igual a Fecha Desde', 'error');
			}

		} else {
			swal('Error', 'Campos Incompletos', 'error');
		}
	}

	crossmatchTime() {
		var object = {};
		object.start_date = this.state.start_date;
		object.end_date = this.state.end_date;
		object.health_facilities_id = sessionStorage.getItem('health_facilities_id');

		fetch(Config.default.apiGateway.URL + 'reports/crossmatch_time', {
			method: 'post',
			body: JSON.stringify(object),
			responseType: 'blob', //Force to receive data in a Blob Format
			headers: new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token"),
				'Content-Type': 'application/json'
			})
		})
			.then(res => {
				this.props.waiting.handleClose();
				if (res.ok) {
					return res.json();
				} else {
					res.text().then((msg) => {
						swal('Error', msg, 'error');
					});
				}
			})
			.then(response => {
				if (response !== undefined) {

					if ($.fn.DataTable.isDataTable(this.el)) {
						$(this.el).DataTable().destroy();
						$(this.el).empty();
					}

					var list = [];
					var results = [];
					var pdf_list = [];
					var pdf_res = [];
					var body = [];

					if (response.resp && Array.isArray(response.resp)) {
						response.resp.map((res) => {
							if (res) {
								list.push([
									res.sample_number || "",
									res.timestamp_petition !== null ? moment(res.timestamp_petition).format('DD/MM/YYYY HH:mm') : "",
									res.timestamp_sample !== null ? moment(res.timestamp_sample).format('DD/MM/YYYY HH:mm') : "",
									res.timestamp_reserved !== null ? moment(res.timestamp_reserved).format('DD/MM/YYYY HH:mm') : "",
									res.unit_number || "",
									res.user || ""
								]);
							}
						});
					}

					this.state.columns_list.forEach((columns) => {
						body = [];
						columns.forEach(col => {
							var obj = { text: col.title, style: 'tableHeader' };
							if (col.colSpan !== undefined) {
								obj.colSpan = col.colSpan;
								body.push(obj);
								for (var i = 1; i < col.colSpan; i++) {
									body.push({ text: '' });
								}
							} else {
								body.push(obj);
							}

						})
						pdf_list.push(body);
					})

					list.forEach((listado, i) => {
						body = [];
						listado.forEach((l, j) => {
							var obj = {
								text: l,
								style: i % 2 === 0 ? 'tableBodyEven' : 'tableBodyOdd'
							}

							body.push(obj);
						})

						if (listado.length === 9) {
							body.unshift({ text: '' });
						}

						pdf_list.push(body);
					})

					body = [];
					this.state.columns_results.forEach(col => {
						var obj = { text: col.title, style: 'tableHeader' }
						if (col.rowSpan !== undefined) {
							obj.rowSpan = col.rowSpan;
							body.push(obj);
						}

						if (col.colSpan !== undefined) {
							obj.colSpan = col.colSpan;
							body.push(obj);
							for (var i = 1; i < col.colSpan; i++) {
								body.push({ text: '' });
							}
						}
					});
					pdf_res.push(body);
					body = [];
					this.state.columns_results.forEach(col => {
						if (col.cols !== undefined) {
							col.cols.forEach((c) => {
								var obj = { text: c.title, style: 'tableHeader' }
								if (c.rowSpan !== undefined) {
									obj.rowSpan = c.rowSpan;
									body.push(obj);
								}

								if (c.colSpan !== undefined) {
									obj.colSpan = c.colSpan;
									body.push(obj);
									for (var i = 1; i < c.colSpan; i++) {
										body.push({ text: '' });
									}
								}

							});
						} else {
							body.push({ text: '' });
						}
					});
					pdf_res.push(body);
					body = [];
					this.state.columns_results.forEach(col => {
						if (col.cols !== undefined) {
							col.cols.forEach((c) => {
								if (c.cols !== undefined) {
									c.cols.forEach((item) => {
										body.push({ text: item.title, style: 'tableHeader' });
									})
								} else {
									body.push({ text: '' });
								}

							});
						} else {
							body.push({ text: '' });
						}
					});
					pdf_res.push(body);
					results.forEach(result => {
						body = [];
						result.forEach((res, i) => {
							var obj = {
								text: res,
								style: i % 2 === 0 ? 'tableBodyEven' : 'tableBodyOdd'
							}

							body.push(obj);
						});
						pdf_res.push(body);
					})

					this.setState({
						listado: Array.isArray(list) ? list : [],
						total: response.total || 0,
						buttonsState: list.length > 0 ? false : true,
						pdf_listado: this.preparePdfData(Array.isArray(list) ? list : [], 'DETALLADO'),
						pdf_results: Array.isArray(pdf_res) ? pdf_res : []
					});

					setTimeout(() => {
						this.props.waiting.handleShow('Cargando...');
						this.$el = $(this.el);
					}, 500);

					setTimeout(() => {
						this.props.waiting.handleClose();
						this.setTable();
					}, 1000);
					this.props.waiting.handleClose();

				} else {
					swal('Error', 'Campos Incompletos', 'error');
				}

			})
	}

	compatibilitySamplebags() {
		var object = {};
		object.start_date = this.state.start_date;
		object.end_date = this.state.end_date;
		object.health_facilities_id = sessionStorage.getItem('health_facilities_id');

		fetch(Config.default.apiGateway.URL + 'reports/compatibility_samplebags', {
			method: 'post',
			body: JSON.stringify(object),
			responseType: 'blob', //Force to receive data in a Blob Format
			headers: new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token"),
				'Content-Type': 'application/json'
			})
		})
			.then(res => {
				this.props.waiting.handleClose();
				if (res.ok) {
					return res.json();
				} else {
					res.text().then((msg) => {
						swal('Error', msg, 'error');
					});
				}
			})
			.then(response => {
				if (response !== undefined) {

					if ($.fn.DataTable.isDataTable(this.el)) {
						$(this.el).DataTable().destroy();
						$(this.el).empty();
					}

					var list = [];
					var results = [];
					var pdf_list = [];
					var pdf_res = [];
					var body = [];

					if (response.resp && Array.isArray(response.resp)) {
						list = response.resp.map(res => {
							if (res) {
								return [
									res.COMPONENTE || "",
									res.COMPATIBLE || "",
									res.INCOMPATIBLE || "",
									res.MENOS_INCOMPATIBLE || "",
									res.TOTAL || ""
								];
							}
							return null;
						}).filter(item => item !== null);
					} else {
						list = [];
					}

					this.setState({
						columns: [
							{ title: 'Componente', width: '40%' },
							{ title: 'Compatibles', width: '15%' },
							{ title: 'Incompatibles', width: '15%' },
							{ title: 'Menos Incompatibles', width: '15%' },
							{ title: 'Total', width: '15%' },
						],
						columns_list: [[
							{ title: 'Componente' },
							{ title: 'Compatibles' },
							{ title: 'Incompatibles' },
							{ title: 'Menos Incompatibles' },
							{ title: 'Total' },
						]]
					});


					this.state.columns_list.forEach((columns) => {
						body = [];
						columns.forEach(col => {
							var obj = { text: col.title, style: 'tableHeader' };
							if (col.colSpan !== undefined) {
								obj.colSpan = col.colSpan;
								body.push(obj);
								for (var i = 1; i < col.colSpan; i++) {
									body.push({ text: '' });
								}
							} else {
								body.push(obj);
							}

						})
						pdf_list.push(body);
					})

					list.forEach((listado, i) => {
						body = [];
						listado.forEach((l, j) => {
							var obj = {
								text: l,
								style: i % 2 === 0 ? 'tableBodyEven' : 'tableBodyOdd'
							}

							body.push(obj);
						})

						if (listado.length === 9) {
							body.unshift({ text: '' });
						}

						pdf_list.push(body);
					})

					body = [];
					this.state.columns_results.forEach(col => {
						var obj = { text: col.title, style: 'tableHeader' }
						if (col.rowSpan !== undefined) {
							obj.rowSpan = col.rowSpan;
							body.push(obj);
						}

						if (col.colSpan !== undefined) {
							obj.colSpan = col.colSpan;
							body.push(obj);
							for (var i = 1; i < col.colSpan; i++) {
								body.push({ text: '' });
							}
						}
					});
					pdf_res.push(body);
					body = [];
					this.state.columns_results.forEach(col => {
						if (col.cols !== undefined) {
							col.cols.forEach((c) => {
								var obj = { text: c.title, style: 'tableHeader' }
								if (c.rowSpan !== undefined) {
									obj.rowSpan = c.rowSpan;
									body.push(obj);
								}

								if (c.colSpan !== undefined) {
									obj.colSpan = c.colSpan;
									body.push(obj);
									for (var i = 1; i < c.colSpan; i++) {
										body.push({ text: '' });
									}
								}

							});
						} else {
							body.push({ text: '' });
						}
					});
					pdf_res.push(body);
					body = [];
					this.state.columns_results.forEach(col => {
						if (col.cols !== undefined) {
							col.cols.forEach((c) => {
								if (c.cols !== undefined) {
									c.cols.forEach((item) => {
										body.push({ text: item.title, style: 'tableHeader' });
									})
								} else {
									body.push({ text: '' });
								}

							});
						} else {
							body.push({ text: '' });
						}
					});
					pdf_res.push(body);
					results.forEach(result => {
						body = [];
						result.forEach((res, i) => {
							var obj = {
								text: res,
								style: i % 2 === 0 ? 'tableBodyEven' : 'tableBodyOdd'
							}

							body.push(obj);
						});
						pdf_res.push(body);
					})

					this.setState({
						listado: Array.isArray(list) ? list : [],
						total: response.total || 0,
						buttonsState: list.length > 0 ? false : true,
						pdf_listado: this.preparePdfData(Array.isArray(list) ? list : [], 'ESTADISTICO'),
						pdf_results: Array.isArray(pdf_res) ? pdf_res : []
					});

					setTimeout(() => {
						this.props.waiting.handleShow('Cargando...');
						this.$el = $(this.el);
					}, 500);

					setTimeout(() => {
						this.props.waiting.handleClose();
						this.setTable();
					}, 1000);
					this.props.waiting.handleClose();

				} else {
					swal('Error', 'Campos Incompletos', 'error');
				}

			})
	}

	preparePdfData = (data, reportType) => {
    const pdfData = [];
    
    if (!Array.isArray(data)) {
        console.warn('Los datos para PDF no son un array válido:', data);
        return pdfData;
    }
    
    if (reportType === 'DETALLADO') {
        pdfData.push([
            { text: 'Muestra', style: 'header' },
            { text: 'F. Petición', style: 'header' },
            { text: 'F. Muestra', style: 'header' },
            { text: 'F. Reserva', style: 'header' },
            { text: 'Unidad', style: 'header' },
            { text: 'Usuario', style: 'header' },
        ]);
    } else {
        pdfData.push([
            { text: 'Componente', style: 'header' },
            { text: 'Compatibles', style: 'header' },
            { text: 'Incompatibles', style: 'header' },
            { text: 'Menos Incompatibles', style: 'header' },
            { text: 'Total', style: 'header' },
        ]);
    }
    
    // Agregar datos
    data.forEach(item => {
        if (Array.isArray(item)) {
            pdfData.push(item);
        }
    });
    
    return pdfData;
};

	dateCompare() {
		var ini = moment(this.state.start_date);
		var fin = moment(this.state.end_date);
		var date_ok = true;

		if (ini !== 'Invalid date' && fin !== 'Invalid date') {
			if (fin < ini) {
				date_ok = false;
				document.getElementById('end_date').classList.add('error');
			} else {
				document.getElementById('end_date').classList.remove('error');
			}
		} else {
			date_ok = false;
		}

		return date_ok;
	}

	isValidForm() {
		const select = document.querySelector('form');
		const inputs = select.querySelectorAll('input, select');
		let isFormValid = true;

		inputs.forEach(input => {
			if (input.required) {

				const isInputValid = this.showCtrlError(input.name);
				if (!isInputValid) {
					isFormValid = false;
				}
			}
		});

		return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		if (this.state[refName] === "") {
			if (control !== null) {
				control.classList.add('error');
			}
			res = false;
		} else {
			if (control !== null) {
				if (control.required && control.className.includes('error')) {
					control.classList.remove('error');
				}
			}
			res = true;
		}

		return res;
	}

	generatePdf(e) {
		e.preventDefault();


		let tableDefinition;

		if (this.state.report_type === "DETALLADO") {
			tableDefinition = {
				body: this.state.pdf_listado,
				widths: ['15%', '15%', '15%', '15%', '20%', '20%'],
				headerRows: 1
			};
		} else if (this.state.report_type === "ESTADISTICO") {
			tableDefinition = {
				body: this.state.pdf_listado,
				widths: ['40%', '15%', '15%', '15%', '15%'],
				headerRows: 1
			};
		} else {
			swal('Error', 'Tipo de reporte no válido', 'error');
			return;
		}


		if (!tableDefinition.body || tableDefinition.body.length === 0) {
			swal('Error', 'No hay datos para generar el reporte', 'error');
			return;
		}


		const expectedColumns = tableDefinition.widths.length;
		const actualColumns = tableDefinition.body[0]?.length || 0;

		if (actualColumns !== expectedColumns) {
			console.error(`Discrepancia en columnas: Esperadas ${expectedColumns}, Recibidas ${actualColumns}`);
			swal('Error', 'Configuración incorrecta del reporte', 'error');
			return;
		}


		const docDefinition = {
			content: [
				{
					image: this.props.header_document,
					alignment: 'center',
					width: this.props.w_head
				},
				{
					text: this.state.filename,
					style: 'title',
					margin: [0, 0, 0, 12]
				},
				{
					text: `Del ${moment(this.state.start_date).format("DD/MM/YYYY")} al ${moment(this.state.end_date).format("DD/MM/YYYY")}`,
					margin: [0, 0, 0, 10]
				},
				{
					table: tableDefinition,
					layout: 'lightHorizontalLines'
				}
			],
			styles: {
				title: {
					fontSize: 16,
					bold: true,
					alignment: 'center'
				},
				header: {
					fillColor: '#2d4154',
					color: 'white',
					bold: true
				}
			},
			pageOrientation: 'landscape',
			footer: (currentPage, pageCount) => ({
				text: `${this.state.date_hour} - Página ${currentPage} de ${pageCount}`,
				alignment: 'right',
				margin: [0, 10, 20, 0]
			})
		};

		try {
			pdfMake.createPdf(docDefinition).download(`${this.state.filename}.pdf`);
		} catch (error) {
			console.error('Error generando PDF:', error);
			swal('Error', 'Ocurrió un error al generar el PDF', 'error');
		}
	}

	generateExcel(e) {
		e.preventDefault();

		var obj = {
			start_date: this.state.start_date,
			end_date: this.state.end_date,
			health_facilities_id: this.state.health_facilities_id
		};

		let report_name ='';

		if (this.state.report_type === "DETALLADO") {
			report_name = 'crossmatch_time';
		} else if (this.state.report_type === "ESTADISTICO") {
			report_name = 'compatibility_samplebags';
		}

		fetch(Config.default.apiGateway.URL + 'reports/generate_excel?report_name='+report_name, {
			method: 'POST',
			body: JSON.stringify(obj),
			responseType: 'blob',
			headers: new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem('token'),
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			})
		}).then(res => {
			if (res.ok) {
				return res.blob();
			} else {
				res.text().then((msg) => {
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if (response !== undefined) {
				this.props.fileDownload(this.state.filename, ".xlsx", 'application/vnd.ms-excel', response);
			}
		})

	}

	render() {
		const { t } = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page">
						{session} ->
						{t('sidebar.nav.reports.MAIN')} ->
					Pacientes ->
						{this.state.filename}
					</h5>
				</div>
				<div className="form-group" style={{ paddingLeft: "0.5em" }}>

					<div className="col-xs-12">
						<form noValidate>
							<div className="col-xs-12 col-sm-2" style={{ borderRight: "1px solid #e0e0e0" }}>

								<div className="form-group">
									<span className="span-min">Fecha Desde</span>
									<input type="date" className="form-control hour-input" name="start_date" id="start_date"
										value={this.state.start_date} onChange={this.handleChange} required />
								</div>
								<div className="form-group">
									<span className="span-min">Fecha Hasta</span>
									<input type="date" className="form-control hour-input" name="end_date" id="end_date"
										value={this.state.end_date} onChange={this.handleChange} required />
								</div>

								<div className="form-group">
									<span className="span-min">Tipo Reporte</span>
									<select className="form-control" name="report_type" id="report_type"
										value={this.state.report_type} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="DETALLADO">Detallado</option>
										<option value="ESTADISTICO">Estadístico</option>
									</select>
								</div>

								<div style={{ textAlign: "right" }}>
									<button type="button" className="btn btn-info" onClick={this.searching} style={{ fontSize: "1em" }}>
										Buscar
									</button>
								</div>
							</div>

							<div className="col-xs-12 col-sm-10">
								<div className="col-xs-12">
									<div className="col-xs-12 col-sm-12" style={{ marginTop: "20px", textAlign: "center", fontWeight: "bold", textDecoration: "underline", fontSize: '16px' }}>
										<span>
											{this.state.filename}
										</span>
									</div>
									<div className="col-xs-12 col-sm-12" >
										<span>
											Del:  {this.state.start_date !== "" ?
												moment(this.state.start_date).format("DD/MM/YYYY")
												: ''}
										</span>
										<span style={{ marginLeft: "5px" }}>
											Al: {this.state.end_date !== "" ?
												moment(this.state.end_date).format("DD/MM/YYYY")
												: ''}
										</span>
									</div>
								</div>
								<div className="col-xs-12 form-group" style={{ textAlign: 'right' }}>
									<button className="btn btn-default" disabled={this.state.buttonsState} onClick={(e) => this.generateExcel(e)} style={{ marginRight: 8 }}>Excel</button>
									<button className="btn btn-default" disabled={this.state.buttonsState} onClick={(e) => this.generatePdf(e)}>PDF</button>
								</div>
								<div className="col-xs-12 form-group" id="table-to-pdf">
									<div className="table-responsive">
										<table style={{ fontSize: "11px" }} id="table-to-xls" className="expenses-discards" ref={el => this.el = el}>
										</table>
									</div>

								</div>
								<div className="col-xs-12 form-group">
									{this.state.report_type === "DETALLADO" &&
										<>
											<label>Total:</label>
											<span>{this.state.total}</span>
										</>
									} 
								</div>
							</div>
						</form>
					</div>
				</div>
			</div>
		)
	}
}

export default translate('translations')(Crossmatch);